[
    {
        "policyNumber": "70091347",
        "uqPolicyId": 1042911698,
        "policyId": 849953382,
        "claimId": 902516515,
        "claimNumber": "1550508910",
        "eventDate": "2015-06-17T16:00:00.000+02:00",
        "registerDate": "2015-10-23T00:00:00.000+02:00",
        "reportDate": "2015-10-22T00:00:00.000+02:00",
        "closeDate": "2019-06-04T00:00:00.000+02:00",
        "status": "Uzatvoren\u00fd",
        "paymentAmountSum": 212.44,
        "noPaymCloseFlg": "rejected",
        "lobId": 7,
        "lob": "LI",
        "detailTypeIdentifier": "LIFE-INSURANCE",
        "claimSubj": "Mi\u0161enkov\u00e1 Michaela",
        "liability": 0,
        "claimClassId": 5,
        "claimClassLabel": "\u00daraz",
        "claimTrackLink": null,
        "documents": [
            {
                "itemId": "A1001001A21H11B50858A28273",
                "createTs": "2021-08-11T13:08:58.000+02:00",
                "classid": 7,
                "subclassid": 2,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50301F28041",
                "createTs": "2021-08-11T13:03:01.000+02:00",
                "classid": 7,
                "subclassid": 1,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50257H28009",
                "createTs": "2021-08-11T13:02:57.000+02:00",
                "classid": 7,
                "subclassid": 2,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H10A81823D27670",
                "createTs": "2021-08-10T06:18:23.000+02:00",
                "classid": 7,
                "subclassid": 1,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Ukon\u010denie likvid\u00e1cie"
            }
        ]
    },
    {
        "policyNumber": "38985781",
        "uqPolicyId": 1042911821,
        "policyId": 853643915,
        "claimId": 903736500,
        "claimNumber": "1950306700",
        "eventDate": "2019-06-14T00:00:00.000+02:00",
        "registerDate": "2019-07-02T09:19:16.000+02:00",
        "reportDate": "2019-07-02T09:19:16.000+02:00",
        "closeDate": "2019-07-08T00:00:00.000+02:00",
        "status": "Uzatvoren\u00fd",
        "paymentAmountSum": 0,
        "noPaymCloseFlg": "paid",
        "lobId": 7,
        "lob": "LI",
        "detailTypeIdentifier": "LIFE-INSURANCE",
        "claimSubj": "Mi\u0161enkov\u00e1 Daniela",
        "liability": 0,
        "claimClassId": 5,
        "claimClassLabel": "\u00daraz",
        "claimTrackLink": null,
        "documents": [
            {
                "itemId": "A1001001A21H11B50858A28273",
                "createTs": "2021-08-11T13:08:58.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50301F28041",
                "createTs": "2021-08-11T13:03:01.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50257H28009",
                "createTs": "2021-08-11T13:02:57.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H10A81823D27670",
                "createTs": "2021-08-10T06:18:23.000+02:00",
                "classid": 3,
                "subclassid": 7,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Ukon\u010denie likvid\u00e1cie"
            }
        ]
    },
    {
        "policyNumber": "0358253169",
        "uqPolicyId": 1018106837,
        "policyId": 1017233794,
        "claimId": 903975189,
        "claimNumber": "2050064180",
        "eventDate": "2019-12-23T00:00:00.000+01:00",
        "registerDate": "2020-02-07T10:27:48.000+01:00",
        "reportDate": "2020-02-07T10:27:48.000+01:00",
        "closeDate": "2020-02-18T00:00:00.000+01:00",
        "status": "Uzatvoren\u00fd",
        "paymentAmountSum": 150,
        "noPaymCloseFlg": null,
        "lobId": 7,
        "lob": "LI",
        "detailTypeIdentifier": "LIFE-INSURANCE",
        "claimSubj": "Mi\u0161enkov\u00e1 Laura",
        "liability": 0,
        "claimClassId": 5,
        "claimClassLabel": "\u00daraz",
        "claimTrackLink": null,
        "documents": [
            {
                "itemId": "A1001001A21H11B50858A28273",
                "createTs": "2021-08-11T13:08:58.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50301F28041",
                "createTs": "2021-08-11T13:03:01.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H11B50257H28009",
                "createTs": "2021-08-11T13:02:57.000+02:00",
                "classid": 3,
                "subclassid": 5,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Vy\u00fa\u010dtovanie"
            },
            {
                "itemId": "A1001001A21H10A81823D27670",
                "createTs": "2021-08-10T06:18:23.000+02:00",
                "classid": 3,
                "subclassid": 7,
                "visible": true,
                "classidLabel": "Poistn\u00e9 udalosti ne\u017eivot",
                "subclassidLabel": "Ukon\u010denie likvid\u00e1cie"
            }
        ]
    }
]
